import { ApiUrl } from 'src/constants';
import { httpService } from 'src/services';
import { Response } from 'src/api/hydraResponse';
import { IAppRequest } from 'src/typings/app';

export function getComplexDefaultConfigById(lang: string): Promise<Response<IAppRequest>> {
  return httpService.get(`${ApiUrl.getApiUrl().getComplexDefaultConfigById}&lang=${lang}`);
}

export function getComplexDefaultConfig(complexId: string, lang: string): Promise<Response<IAppRequest>> {
  return httpService.get(`${ApiUrl.getApiUrl().getComplexDefaultConfig}?id=${complexId}&lang=${lang}`);
}

export function getGroupedPlacementsConfig(lang: string) {
  return httpService.get(`${ApiUrl.getApiUrl().getGroupedPlacementsConfig}&lang=${lang}`);
}

export function getClientModuleMenu(lang: string) {
  return httpService.get(`${ApiUrl.getApiUrl().getClientMenuModule}&lang=${lang}`);
}
